//import vueAreaSelect from './components/vue-area-select'   //引入组件
//import scroll from './components/scroll1.vue'   //引入组件
import loading from './components/loading.vue'   //引入组件
import shape from './components/shape.vue'   //引入组件
// import 'font-awesome/css/font-awesome.css'
const webuitools = {
// const loadings = {
  install (Vue, options) {
//    Vue.component(vueAreaSelect.name, vueAreaSelect) //全局组件
   Vue.component(loading.name, loading) //全局组件
   Vue.component(shape.name, shape) //全局组件
   // Vue.component(scroll.name, scroll) //全局组件
//    Vue.component(dates.name, dates) //全局组件
  }
}

// export default shapes  //导出
export default webuitools  //导出
//



// WEBPACK FOOTER //
// ./src/index.js